import { Component, Input, OnInit } from '@angular/core';
import { messageService } from '../message.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  firstLevel: string = "";
  secondLevel: string = "";
  thirdLevel: string = "";
  fourthLevel: string = "";
  fifthLevelFromDependency: string = "";
  sixthLevelFromDependency: string = "";
  
  constructor(public message: messageService, public router: Router) { }

  ngOnInit() {
    this.updateBreadcrumb();
  }

  ngDoCheck() {
    // Update breadcrumb whenever change detection runs
    this.updateBreadcrumb();
  }

  private updateBreadcrumb() {
    this.firstLevel = this.message.breadcrumbData.firstLevel;
    this.secondLevel = this.message.breadcrumbData.secondLevel;
    this.thirdLevel = this.message.breadcrumbData.thirdLevel;
    this.fourthLevel = this.message.breadcrumbData.fourthLevel;
    this.fifthLevelFromDependency = this.message.breadcrumbData.fifthLevelFromDependency;
    this.sixthLevelFromDependency = this.message.breadcrumbData.sixthLevelFromDependency;
  }

  navigation(level: String, pagename: String) {
    if(level=='firstLevel'){
      if(pagename=="Dashboard"){
        
      }
    }else if(level=='secondLevel'){
        //levelTwo
        if(pagename=='Manage Trainings'){
          this.message.breadcrumbData.thirdLevel="";
          this.router.navigate(['/dashboard/manageTraining']);
        }else if(pagename=='FlexiFields'){
          this.router.navigate(['/dashboard/flexfieldSetup']);
        }else if(pagename=='User Management'){
          this.router.navigate(['/dashboard/users']);
        }
      
    }else if(level=='secondLevel'){

    }
  }

}
